export const asksBeforeRequired = (next: boolean, usedBy: number): boolean =>
  next && usedBy > 0;

export type FolderFlag = "alwaysRequired" | "perStore";

export const setAllPlan = <
  T extends { alwaysRequired: boolean; perStore: boolean; usedBy: number },
>(
  leaves: T[],
  flag: FolderFlag,
  next: boolean,
): { change: T[]; live: number } => {
  const change = leaves.filter((l) => l[flag] !== next);
  return { change, live: change.filter((l) => l.usedBy > 0).length };
};
